var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout-footer",
    [
      _c(
        "q-toolbar",
        { staticClass: "mobile-only" },
        [
          _c("q-btn", {
            attrs: { flat: "", round: "", dense: "", icon: "far fa-bars" },
            on: {
              click: function($event) {
                _vm.showLeft = !_vm.showLeft
              }
            }
          })
        ],
        1
      ),
      _c(
        "q-layout-drawer",
        {
          attrs: { side: "left" },
          model: {
            value: _vm.showLeft,
            callback: function($$v) {
              _vm.showLeft = $$v
            },
            expression: "showLeft"
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "", "inset-separator": "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.getProjectName()))]),
              _vm._l(_vm.links, function(link, index) {
                return _c(
                  "q-item",
                  { key: index, attrs: { to: { name: link.to } } },
                  [
                    _c("q-item-side", { attrs: { icon: link.icon } }),
                    _c("q-item-main", { attrs: { label: _vm.$t(link.text) } })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "", "inset-separator": "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.$t("idioms")))]),
              _vm._l(_vm.languages, function(language, index) {
                return _c(
                  "q-item",
                  {
                    key: index,
                    nativeOn: {
                      click: function($event) {
                        return _vm.changeIdiom(language.id)
                      }
                    }
                  },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("flag", {
                          attrs: { iso: language.country_flag, squared: false }
                        })
                      ],
                      1
                    ),
                    _c("q-item-main", { attrs: { label: language.name } })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c("copyright")
        ],
        1
      ),
      _c(
        "q-toolbar",
        {
          staticClass: "desktop-only footer-desktop q-py-md",
          style: _vm.$q.platform.is.edge ? "height: 100px" : ""
        },
        [
          _c("div", { staticClass: "row fit" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "q-mx-xl" }, [
                _c(
                  "ul",
                  [
                    _vm._l(_vm.links, function(link, index) {
                      return [
                        _c(
                          "li",
                          { key: "link" + index },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: link.to } } },
                              [_vm._v(_vm._s(_vm.$t(link.text)))]
                            )
                          ],
                          1
                        ),
                        _c(
                          "li",
                          { key: "div" + index, staticClass: "q-mx-sm" },
                          [_vm._v("|")]
                        )
                      ]
                    }),
                    _vm._l(_vm.languages, function(language, index) {
                      return [
                        _c(
                          "li",
                          {
                            key: "flag" + index,
                            staticClass: "cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.changeIdiom(language.id)
                              }
                            }
                          },
                          [
                            _c("flag", {
                              attrs: {
                                iso: language.country_flag,
                                squared: false
                              }
                            })
                          ],
                          1
                        ),
                        index != Object.keys(_vm.languages).length - 1
                          ? _c(
                              "li",
                              {
                                key: "divflag" + index,
                                staticClass: "q-mx-sm"
                              },
                              [_vm._v("\n\t\t\t\t\t\t\t\t|\n\t\t\t\t\t\t\t")]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 text-center q-mt-sm" }, [
              _c("div", { staticClass: "text-white" }, [
                _c("small", [
                  _vm._v(
                    "Copyright © " +
                      _vm._s(new Date().getFullYear()) +
                      ": " +
                      _vm._s(_vm.getProjectName()) +
                      " v" +
                      _vm._s(_vm.getVersion()) +
                      "\n\t\t\t\t\t\t- Powered by "
                  ),
                  _c("a", { attrs: { href: "https://take5.com.br" } }, [
                    _vm._v("Take 5 LMS")
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 text-center" }, [
              _c("div", { staticClass: "text-white" }, [
                _c("small", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "this_website_is_best_viewed_in_google_chrome_and_mozilla_firefox"
                      )
                    )
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("update") },
                    on: {
                      click: function($event) {
                        return _vm.openStore()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.outdated_app,
            callback: function($$v) {
              _vm.outdated_app = $$v
            },
            expression: "outdated_app"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("outdated_app")))
          ]),
          _c("span", { attrs: { slot: "body" }, slot: "body" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t(
                    "your_app_is_outdated_and_have_to_be_updated_to_log_in"
                  )
                ) +
                "\n\t\t"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }